import { useQuery, useMutation } from 'react-query'
import { apiGetDemoPayloads } from '../api/controller-api'
import { apiPostDemoPayload } from '../api/harness-api'

export const KEY = 'demo-payloads'

export const useDemoPayloads = () => {
  const {
    status,
    data: payloads,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    [KEY],
    async () => {
      const result = await apiGetDemoPayloads()
      return [...result.data].sort((a, b) =>
        a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1,
      )
    },
    {
      refetchOnWindowFocus: false,
    },
  )
  return {
    status,
    payloads,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  }
}

export const usePostDemoPayload = () => {
  return useMutation(({ payload, authToken }) =>
    apiPostDemoPayload({ payload, authToken }),
  )
}
